import { getAccountById } from '../accounts/selectors';
import { getSelectedFromAccountDetails } from '../payeeSelector/selectors';

export const SET_SELECTED_PAYMENT_ID = 'SET_SELECTED_PAYMENT_ID';
export const SET_SELECTED_FROM_ACCOUNT = 'SET_SELECTED_FROM_ACCOUNT';
export const CLEAR_SELECTED_PAYMENT = 'CLEAR_SELECTED_PAYMENT';

export const setSelectedPaymentId = (id) => ({
	type: SET_SELECTED_PAYMENT_ID,
	payload: id,
});

export const setSelectedFromAccount = (fromAccount) => (dispatch, getState) => {
	const state = getState();
	const fromAccountDetails = getAccountById(state, fromAccount); // the account slice might have been wiped by a search
	const selectedFromAccountDetails = getSelectedFromAccountDetails(state);

	if (!fromAccountDetails && selectedFromAccountDetails) return;

	return dispatch({
		type: SET_SELECTED_FROM_ACCOUNT,
		fromAccount: fromAccount,
		fromAccountDetails,
		meta: {
			allowedDuringApiCall: true,
		},
	});
};

export const clearSelectedPayment = () => ({
	type: CLEAR_SELECTED_PAYMENT,
	meta: {
		allowedDuringApiCall: true,
	},
});
